// src/hooks/useUserPreferences.js
import { useEffect, useRef, useState } from 'react'
import { apiFetch } from '../api.js'

const DEFAULT_PREFS = {
  sidebar: {
    favorites: [],
    compact: false,
  },
}

function deepMerge(base, patch) {
  const out = { ...base }
  for (const [k, v] of Object.entries(patch || {})) {
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      out[k] = deepMerge(base?.[k] || {}, v)
    } else {
      out[k] = v
    }
  }
  return out
}

export function useUserPreferences() {
  const [preferences, setPreferences] = useState(DEFAULT_PREFS)
  const [loading, setLoading] = useState(false)
  const timerRef = useRef(null)

  const save = async (prefs) => {
    await apiFetch('/api/preferences', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ preferences: prefs }),
    })
  }

  const updatePreferences = (patch) => {
    setPreferences((prev) => {
      const next = deepMerge(prev, patch)
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        save(next).catch(() => {})
      }, 400)
      return next
    })
  }

  useEffect(() => {
    let alive = true
    setLoading(true)
    apiFetch('/api/preferences')
      .then((res) => {
        if (!alive) return
        setPreferences(deepMerge(DEFAULT_PREFS, res?.preferences || {}))
      })
      .catch(() => {})
      .finally(() => {
        if (!alive) return
        setLoading(false)
      })
    return () => { alive = false }
  }, [])

  return { preferences, updatePreferences, setPreferences, loading }
}

export default useUserPreferences
